import { PALETTE, paletteToken } from "@/lib/palette";

export default function ColorPicker({ value, onChange, size = "md", testIdPrefix = "color" }) {
  const dim = size === "sm" ? "w-5 h-5" : "w-6 h-6";
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${testIdPrefix}-picker`}>
      {PALETTE.map((c) => {
        const active = value === c.id;
        return (
          <button
            type="button"
            key={c.id}
            data-testid={`${testIdPrefix}-option-${c.id}`}
            onClick={() => onChange(c.id)}
            title={c.label}
            aria-label={c.label}
            className={`${dim} rounded-full border-2 transition-transform ${
              active
                ? "ring-2 ring-offset-2 ring-[#3B2350] dark:ring-[#FBEFF6] dark:ring-offset-[#3B2350] scale-110"
                : "hover:scale-110"
            }`}
            style={{ backgroundColor: c.bg, borderColor: c.hex }}
          />
        );
      })}
    </div>
  );
}

// Small utility for a preview swatch (non-interactive)
export function ColorSwatch({ colorId, className = "" }) {
  const t = paletteToken(colorId);
  return (
    <span
      className={`inline-block w-3 h-3 rounded-full border ${className}`}
      style={{ backgroundColor: t.bg, borderColor: t.hex }}
    />
  );
}
